import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "frisbuy-summary-widget__tags" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsBlock',
  props: {
    tags: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tags, (tag, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "frisbuy-summary-widget__tag",
        key: index
      }, _toDisplayString(tag), 1))
    }), 128))
  ]))
}
}

})